module.exports = __webpack_public_path__ + "static/media/m.7e1c8d61.svg";